import { render, staticRenderFns } from "./joinGroupList.vue?vue&type=template&id=3a405818&scoped=true"
import script from "./joinGroupList.vue?vue&type=script&lang=js"
export * from "./joinGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a405818",
  null
  
)

export default component.exports